module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "mb20"
  }, [_c('blockquote', {
    staticClass: "elem-quote"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _vm._l((_vm.breadCumb), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.name,
      attrs: {
        "to": {
          path: item.path
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a08dc24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/components/BreadCumb.vue
// module id = 926
// module chunks = 0